/* OCT 5 (pdp): mobile sticky ADD HEAT bar for the SOLO + ULTRA product sections.
   The bar ([data-pf-sticky]) is hidden on load by assets/pf-white-pdp.css. It only slides in once the main
   Add to Cart button ([data-pf-atc]) has scrolled up out of the viewport (not intersecting AND its top is above
   the viewport), and slides out again as soon as that button is back in view. Because the colour picker sits
   above the main button, the bar can never cover it.
   Variant, price and quantity sync stays where it was: assets/pf-solo-pdp.js (SOLO) and the ULTRA section script. */
(function () {
  'use strict';

  function setup(root) {
    if (!root || root.dataset.pfStickyReady === 'true') return;
    var bar = root.querySelector('[data-pf-sticky]');
    var atc = root.querySelector('[data-pf-atc]');
    if (!bar || !atc) return;
    root.dataset.pfStickyReady = 'true';

    var shown = null;
    function set(show) {
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !show;
      document.documentElement.classList.toggle('pf-sticky-on', show);
    }
    set(false);

    function decide(rect, intersecting) {
      set(!intersecting && rect.top < 0);
    }

    /* Added-to-cart feedback: product-form.js fires 'pf:cart-added' on success and then opens the cart drawer as
       before. If the add came from this bar, the button shows a short "Added" state, then returns to its label. */
    var form = bar.querySelector('form');
    var btn = bar.querySelector('[data-pf-sticky-atc]');
    var label = btn && (btn.querySelector('[data-pf-sticky-label]') || btn.querySelector('span'));
    var pending = 0;
    var addedTimer = null;
    if (form && btn && label) {
      form.addEventListener('submit', function () { pending = Date.now(); });
      document.addEventListener('pf:cart-added', function () {
        if (!pending || Date.now() - pending > 15000) return;
        pending = 0;
        var before = label.textContent;
        var added = btn.dataset.addedLabel || 'Added';
        clearTimeout(addedTimer);
        btn.style.minWidth = btn.offsetWidth + 'px';
        btn.classList.add('is-added');
        label.textContent = added;
        addedTimer = setTimeout(function () {
          btn.classList.remove('is-added');
          btn.style.minWidth = '';
          if (label.textContent === added) label.textContent = before;
        }, 1600);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        decide(entry.boundingClientRect, entry.isIntersecting);
      }, { threshold: 0 });
      io.observe(atc);
      root._pfStickyObserver = io;
    } else {
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = atc.getBoundingClientRect();
        decide(r, r.bottom > 0 && r.top < window.innerHeight);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
      }, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('.pf-pdp');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
    if (scope && scope.classList && scope.classList.contains('pf-pdp')) setup(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var nodes = event.target.querySelectorAll('.pf-pdp');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]._pfStickyObserver) nodes[i]._pfStickyObserver.disconnect();
    }
    document.documentElement.classList.remove('pf-sticky-on');
  });
})();
